import React from 'react'
import { Layout } from 'antd'
import HeaderNavigation from '../../components/HeaderNavigation'

import './style.css'
import { ActView } from '../../components/acts'

const { Content } = Layout

const Acts = () => {
  return (
    <Layout>
      <HeaderNavigation activeKey="5" />
      <Content className="site-layout" style={{ padding: '85px 50px', minHeight: '100vh' }}>
        <ActView />
      </Content>
    </Layout>
  )
}

export default Acts
